<template>
    <internal>
        <div class="relative p-6 bg-white border-b border-gray-200 overflow-y-scroll h-screen-80 shadow-sm sm:rounded-lg">
            <p class="text-lg font-medium absolute">List Workshops</p>
            <breeze-table :searchable="true" :fields="fields" :items="workshops" :action="{'text':'add workshop','url':route('internal.workshop.create',branchid)}" :canView="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'View Workshop')" :canCreate="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'Create Workshop')">

                <template #status="data">
                    {{data.item.status?'Active':'Inactive'}}
                </template>
                <template #action="data">
                    <button-link :href="route('internal.workshop.students',[branchid,data.item.id])" :class="'mb-1'" v-if="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'View Workshop')" class="mr-2">Students</button-link>
                    <button-link :href="route('internal.workshop.edit',[branchid,data.item.id])" :class="'mb-1'" v-if="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'Edit Workshop')">Edit</button-link>
                </template>
            </breeze-table>
        </div>
    </internal>
</template>

<script>
    import Internal from '@/Pages/Internal/Internal'
    import BreezeInput from '@/Components/Input'
    import BreezeLabel from '@/Components/Label'
    import ButtonLink from '@/Components/ButtonLink'
    import CardHeader from '@/Components/CardHeader'
    import BreezeInputError from '@/Components/InputError'
    import BreezeButton from '@/Components/Button'
    import BreezeCheckbox from '@/Components/Checkbox'
    import Loading from '@/Components/Loading'
    import SelectList from '@/Components/SelectList'
    import Exception from '@/Components/Exception'
    import BreezeTable from '@/Components/Table'

    export default {
        components: {
            Internal,
            BreezeInput,
            BreezeLabel,
            ButtonLink,
            CardHeader,
            BreezeInputError,
            BreezeButton,
            BreezeCheckbox,
            Loading,
            Exception,
            BreezeTable,
            SelectList
        },
        props:['workshops'],
        data(){
            return{
                fields:[{'key':'title','label':'Title'},{'key':'faculty_name','label':'Faculty Name'},{'key':'deadline_at','label':'Deadline'},{'key':'workshop_at','label':'Workshop At'},{'key':'status','label':'Status'},{'key':'action','label':'Action'}],
                branchid:localStorage.branchId,
            }
        },

    }
</script>
